import { render, staticRenderFns } from "./kai.vue?vue&type=template&id=69403065&scoped=true&"
import script from "./kai.vue?vue&type=script&lang=js&"
export * from "./kai.vue?vue&type=script&lang=js&"
import style0 from "./kai.vue?vue&type=style&index=0&id=69403065&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69403065",
  null
  
)

export default component.exports